import { HistogramWidth, TimeRange } from "@vviinn/user-managment-client-ts";

// Each supported time period has one fixed, non-selectable histogram bucket width.
const FIXED_HISTOGRAM_WIDTH_BY_TIME_RANGE: Partial<
  Record<TimeRange, HistogramWidth>
> = {
  last_hour: "minutely",
  day: "hourly",
  month: "daily",
  last_year: "monthly",
};

export const getFixedHistogramWidth = (timeRange: TimeRange): HistogramWidth =>
  FIXED_HISTOGRAM_WIDTH_BY_TIME_RANGE[timeRange] ?? "daily";
